import React, { useEffect, useState, useRef } from "react"
import "./AddCourse.scss"
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Row,
  Spinner,
} from "reactstrap"
import CustomBreadCrumb from "utils/CustomBreadCrumb/CustomBreadCrumb"
import Country from "../../../utils/Data/Country"
import * as Yup from "yup"
import { InputText } from "primereact/inputtext"
import { Dropdown } from "primereact/dropdown"
import { Calendar } from "primereact/calendar"
import { InputNumber } from "primereact/inputnumber"
import { useNavigate, useLocation } from "react-router-dom"
import CourseApi from "Api/CourseApi"
import UniversityApi from "Api/UniversityApi"
import programApi from "Api/programApi"
import { Toast } from 'primereact/toast'

const AddCourse = () => {
  document.title = "Add Course"
  const [loading, setLoading] = useState(false)
  const toast = useRef(null);
  const navigate = useNavigate("")
  const location = useLocation()
  const accessToken = localStorage.getItem("accessToken")
  const CourseInitialData = {
    courseName: "",
    duration: "",
    Program: "",
    level: "",
    eligibilityCriteria: "",
    totalSeats: "",
    tuitionFee: "",
    admissionFee: "",
    intakeSeats: "",
    modeOfStudy: "",
    description: "",
    university: "",
    institution: "",
    cutoffs: [],
  }

  const [courseData, setCourseData] = useState(CourseInitialData)
  const [currentCutoff, setCurrentCutoff] = useState({
    year: "",
    quota: "",
    cutoff: "",
    rounds: {
      round1: "TBA",
      round2: "TBA",
      mopUpRound: "TBA",
      strayVacancy: "TBA",
    },
  })

   const programOptions = [
    { label: "Undergraduate", value: "Undergraduate" },
    { label: "Postgraduate", value: "Postgraduate" },
    { label: "Certification Program", value: "Certification Program" },
    { label: "Fellowship", value: "Fellowship" }
  ];
  
  const quotaOptions = [
    { name: "General", code: "General" },
    { name: "OBC", code: "OBC" },
    { name: "SC", code: "SC" },
    { name: "ST", code: "ST" },
    { name: "EWS", code: "EWS" },
  ]

  const [errors, setErrors] = useState({})
  const handleCourseDataChange = (name, value) => {
    if (name === "institution") {
      setCourseData(prevData => {
        const newData = { ...prevData, [name]: value }
        return newData
      })
    } else {
      setCourseData(prevData => ({ ...prevData, [name]: value }))
    }
    setErrors({ ...errors, [name]: "" })
  }

  const handleAddCutoff = () => {
    // Basic validation for year and quota
    if (!currentCutoff.year || !currentCutoff.quota) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Year and Quota are required",
        life: 3000,
      })
      return
    }

    // Additional validation based on institution category
    if (courseData.institution?.category?.toUpperCase() === "MEDICAL") {
      // For medical institutions, check rounds
      if (!currentCutoff.rounds.round1 || !currentCutoff.rounds.round2 ||
        !currentCutoff.rounds.mopUpRound || !currentCutoff.rounds.strayVacancy) {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "All rounds are required for medical institutions",
          life: 3000,
        })
        return
      }
    } else {
      // For non-medical institutions, check cutoff
      if (!currentCutoff.cutoff) {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Cutoff value is required",
          life: 3000,
        })
        return
      }
    }

    const newCutoff = {
      year: currentCutoff.year,
      quota: currentCutoff.quota.code || currentCutoff.quota,
      cutoff: currentCutoff.cutoff,
      rounds: courseData.institution?.category?.toUpperCase() === "MEDICAL" ? {
        round1: currentCutoff.rounds.round1,
        round2: currentCutoff.rounds.round2,
        mopUpRound: currentCutoff.rounds.mopUpRound,
        strayVacancy: currentCutoff.rounds.strayVacancy,
      } : null
    }

    const updatedCutoffs = [...courseData.cutoffs, newCutoff]
    handleCourseDataChange("cutoffs", updatedCutoffs)

    // Reset the form
    setCurrentCutoff({
      year: "",
      quota: "",
      cutoff: "",
      rounds: {
        round1: "",
        round2: "",
        mopUpRound: "",
        strayVacancy: "",
      },
    })

    toast.current.show({
      severity: "success",
      summary: "Success",
      detail: "Cutoff added successfully",
      life: 3000,
    })
  }

  const handleRemoveCutoff = index => {
    const updatedCutoffs = courseData.cutoffs.filter((_, i) => i !== index)
    handleCourseDataChange("cutoffs", updatedCutoffs)
  }

  const breadcrumbItems = [
    { label: "Pixwik", link: "#" },
    { label: "Course", link: "#" },
    { label: "Add Course", link: "#" },
  ]
  const typeOptions = [
    { name: "underGraduate", code: "underGraduate" },
    { name: "postGraduate", code: "postGraduate" },
  ]
  const approvalOptions = [
    { name: "Yes", code: "Yes" },
    { name: "No", code: "No" },
  ]
  const modeofStudyOptions = [
    { name: "Online", code: "Online" },
    { name: "Offline", code: "Offline" },
    { name: "Hybrid", code: "Hybrid" },
  ]
  const [uniMenu, setUniMenu] = useState([])
  const universityDropDown = () => {
    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    }

    UniversityApi.getUniversityMenuList(config)
      .then(res => {
        setUniMenu(res.data.university)
      })
      .catch(error => {
      })
  }
  useEffect(() => {
    universityDropDown()
  }, [accessToken])
  const [programMenu, setProgramMenu] = useState([])

  const programList = programMenu?.map(program => ({
    name: program.programName,
    code: program._id,
  })) || []

  const getProgramMenuList = (institutionCode, institution) => {
    if (!institution) {
      toast.current.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Please select an institution first',
        life: 3000
      });
      return;
    }

    if (!institution.category) {
      toast.current.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Institution category is required',
        life: 3000
      });
      return;
    }

    const category = institution.category;
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }

    programApi
      .getProgramByInstitue(institutionCode, category, config)
      .then(res => {
        if (res.data.status) {
          setProgramMenu(res.data.programs || [])
        }
      })
      .catch(error => {
        toast.current.show({
          severity: 'error',
          summary: 'Error',
          detail: error.response?.data?.message || 'Failed to fetch programs',
          life: 3000
        });
      })
  }

  const [instituteMenu, setInstituteMenu] = useState([])
  const fetchInstituteByUniId = universityCode => {
    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    }
    UniversityApi.getCollegesByUniversity(universityCode, config)
      .then(res => {
        setInstituteMenu(res.data.colleges)
      })
      .catch(error => {
        console.log(error)
      })
  }

  // Store pending institution data to set after instituteMenu loads
  const pendingInstitutionRef = useRef(null)
  const pendingUniversityRef = useRef(null)

  // Auto-populate fields when coming from Data Completion Dashboard
  useEffect(() => {
    if (location.state && !courseData.university && !courseData.institution) {
      console.log('=== Add Course - Received State ===')
      console.log('Location state:', location.state)

      const { institutionId, institutionCode, institutionName, universityId, universityCode, universityName, category } = location.state

      // If we have university data
      if (universityId && universityCode && universityName) {
        // Create university object with all required fields
        const university = {
          _id: universityId,
          universityCode: universityCode,
          universityName: universityName
        }

        // Store university data to be set after uniMenu loads
        pendingUniversityRef.current = {
          _id: universityId,
          universityCode: universityCode,
          universityName: universityName
        }

        // Fetch institutions for this university
        fetchInstituteByUniId(universityCode)

        // Store institution data to be set after instituteMenu loads
        pendingInstitutionRef.current = {
          _id: institutionId,
          institutionCode: institutionCode,
          institutionName: institutionName,
          category: category
        }
      } else if (institutionId && institutionCode && institutionName) {
        // If no university but we have institution info
        const institution = {
          _id: institutionId,
          institutionCode: institutionCode,
          institutionName: institutionName,
          category: category
        }

        console.log('Setting institution (no university):', institution)

        // IMPORTANT: Add the institution to instituteMenu so the dropdown can display it
        setInstituteMenu([institution])

        // Set the institution in the form
        handleCourseDataChange("institution", institution)

        // Fetch programs for this institution
        if (institutionCode && category) {
          getProgramMenuList(institutionCode, institution)
        }

        toast.current.show({
          severity: 'info',
          summary: 'Institution Pre-filled',
          detail: `Institution "${institutionName}" has been pre-selected. Please select a university.`,
          life: 3000
        })
      }
    }
  }, [location.state])

  // Set university when uniMenu is populated
  useEffect(() => {
    if (pendingUniversityRef.current && uniMenu.length > 0) {
      const pendingUni = pendingUniversityRef.current
      const matchedUni = uniMenu.find(u => u._id === pendingUni._id || u.universityCode === pendingUni.universityCode)

      if (matchedUni) {
        console.log('Found matching university in menu:', matchedUni)
        handleCourseDataChange("university", matchedUni)
      } else {
        console.warn('Could not find matching university in menu for:', pendingUni)
      }
      pendingUniversityRef.current = null
    }
  }, [uniMenu])

  // Set institution when instituteMenu is populated
  useEffect(() => {
    if (pendingInstitutionRef.current && instituteMenu.length > 0) {
      const pendingInst = pendingInstitutionRef.current

      // Find the matching institution object from the loaded menu
      const matchedInstitution = instituteMenu.find(
        inst => inst._id === pendingInst._id || inst.institutionCode === pendingInst.institutionCode
      )

      if (matchedInstitution) {
        console.log('Found matching institution in menu:', matchedInstitution)
        handleCourseDataChange("institution", matchedInstitution)

        // Fetch programs for this institution
        if (matchedInstitution.institutionCode && matchedInstitution.category) {
          getProgramMenuList(matchedInstitution.institutionCode, matchedInstitution)
        }

        toast.current.show({
          severity: 'success',
          summary: 'Pre-filled',
          detail: `University and Institution have been pre-selected`,
          life: 3000
        })
      } else {
        console.warn('Could not find matching institution in menu for:', pendingInst)
      }

      // Clear the pending data
      pendingInstitutionRef.current = null
    }
  }, [instituteMenu])

  const ValidateCourse = Yup.object().shape({
    courseName: Yup.string().required("Course name is required"),
    // duration: Yup.string().required("Duration is required"),
    // level: Yup.string().required("Level is required"),
    // eligibilityCriteria: Yup.string().required("Eligibility criteria is required"),
    // totalSeats: Yup.number()
    //   .typeError("Total seats must be a number")
    //   .required("Total seats are required"),
    // tuitionFee: Yup.number()
    //   .typeError("Tuition fee must be a number")
    //   .required("Tuition fee is required"),
    // admissionFee: Yup.number()
    //   .typeError("Admission fee must be a number")
    //   .required("Admission fee is required"),
    // intakeSeats: Yup.number()
    //   .typeError("Invalid Intake Seats")
    //   .required("Intake Seats is required"),
    // modeOfStudy: Yup.string()
    //   .oneOf(["online", "offline", "hybrid"], "Invalid Mode of Study")
    //   .required("Mode of study is required"),
    // description: Yup.string().required("Description is required"),
    institution: Yup.object().shape({
      _id: Yup.string().required("Institution ID is required"),
      institutionId: Yup.string().required("Institution code is required"),
      category: Yup.string().required("Institution category is required")
    }).required("Institution is required"),
    program: Yup.string().required("Program is required"),
  })


  const addCourse = () => {
    console.log(courseData,"=== Course Data Before Validation ===")
    // if (!courseData.Program || !courseData?.Program._id) {
    if (!courseData.Program) {
      toast.current.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Please select a program',
        life: 3000
      });
      return;
    }

    const payload = {
      courseName: courseData.courseName,
      university: courseData.university.universityCode,
      duration: courseData.duration,
      level: courseData.level,
      program: courseData.Program,
      eligibilityCriteria: courseData.eligibilityCriteria,
      totalSeats: parseInt(courseData.totalSeats),
      tuitionFee: parseInt(courseData.tuitionFee),
      admissionFee: parseInt(courseData.admissionFee),
      intakeSeats: parseInt(courseData.intakeSeats),
      modeOfStudy: courseData.modeOfStudy.name.toLowerCase(),
      description: courseData.description,
      institution: {
        _id: courseData.institution._id,
        institutionId: courseData.institution.institutionCode,
        category: courseData.institution.category.toLowerCase()
      },
      cutoff: courseData.cutoffs.map(cutoff => ({
        year: parseInt(cutoff.year),
        quota: cutoff.quota,
        cutoff: cutoff.cutoff,
        rounds: cutoff.rounds ? {
          round1: cutoff.rounds.round1,
          round2: cutoff.rounds.round2,
          mopUpRound: cutoff.rounds.mopUpRound,
          strayVacancy: cutoff.rounds.strayVacancy
        } : null
      }))
    }

    console.log( payload,"=== Payload for Validation and Submission ===")
    setLoading(true)

    ValidateCourse.validate(payload, { abortEarly: false })
      .then(() => {
        const config = {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
        CourseApi.addCourse(payload, config)
          .then(res => {
            if (res.data.status) {
              setLoading(false)
              toast.current.show({
                severity: 'success',
                summary: 'Success',
                detail: res.data.message,
                life: 3000
              });
              setTimeout(() => {
                // Navigate back to data completion dashboard if coming from there
                if (location.state?.returnToDashboard) {
                  navigate("/data-completion")
                } else {
                  navigate("/courselist")
                }
              }, 1000)
            }
          })
          .catch(error => {
            setLoading(false)
            toast.current.show({
              severity: 'error',
              summary: 'Error',
              detail: error.response?.data?.message || 'Failed to add course',
              life: 3000
            });
          })
      })
      .catch(err => {
        setLoading(false)
        const validationErrors = {}
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message
        })
        setErrors(validationErrors)
        toast.current.show({
          severity: 'error',
          summary: 'Error',
          detail: "Please fill all the required fields correctly!",
          life: 3000
        });
      })
  }

  return (
    <div className="add-course">
      <Toast ref={toast} />
      <Row>
        <Col xs="12">
          <div className="course-list-header d-flex  align-items-center justify-content-between">
            <CustomBreadCrumb data={breadcrumbItems} pageTitle="Add Course" />
          </div>

          <Card className="mt-4 ">
            <CardBody>
              <div className="course-add-form ">
                <div className="course-add-inp">
                  <label htmlFor="university">University</label>

                  <div className="inp-err">
                    <Dropdown
                      value={courseData.university}
                      onChange={e => {
                        handleCourseDataChange("university", e.value)
                        fetchInstituteByUniId(e.value.universityCode)
                      }}
                      options={uniMenu}
                      optionLabel="universityName"
                      placeholder="Select University"
                      filter
                    />
                    {errors.university && (
                      <small className="error">{errors.university}</small>
                    )}
                  </div>
                </div>

                <div className="course-add-inp">
                  <label
                    htmlFor="
                                    Institution"
                  >
                    Institution
                  </label>

                  <div className="inp-err">
                    <Dropdown
                      value={courseData.institution}
                      onChange={e => {
                        if (e.value) {
                          handleCourseDataChange("institution", e.value);
                          if (e.value.institutionCode) {
                            getProgramMenuList(e.value.institutionCode, e.value);
                          }
                        }
                      }}
                      options={instituteMenu}
                      optionLabel="institutionName"
                      placeholder="Select Institution"
                      filter
                    />
                    {errors.Institution && (
                      <small className="error">{errors.Institution}</small>
                    )}
                  </div>
                </div>
                <div className="course-add-inp">
                  <label htmlFor="CourseName">Program Name</label>
                  <div className="inp-err">
                    <select onChange={e => {
                        handleCourseDataChange("Program", e.target.value);
                      }}>
                      <option value="">Select Program</option>
                      {programOptions.map(program => (
                        <option key={program.value} value={program.value}>
                          {program.label}
                        </option>
                      ))}
                    </select>
                    {/* <Dropdown
                      id="courseName"
                      value={courseData.Program}
                      onChange={e => {
                        handleCourseDataChange("Program", e.value);
                      }}
                      options={programMenu}
                      optionLabel="programName"
                      placeholder="Choose Program"
                      filter
                      className="w-100"
                    /> */}

                    {/* {errors.Program && (
                      <small className="error">{errors.Program}</small>
                    )} */}
                  </div>
                </div>

                <div className="course-add-inp">
                  <label htmlFor="courseName" className="label">
                    Course Name
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="courseName"
                      value={courseData.courseName}
                      onChange={e =>
                        handleCourseDataChange("courseName", e.target.value)
                      }
                      placeholder="Enter Course Name"
                      className="inp-field-box"
                    />
                    {errors.courseName && (
                      <small className="error">{errors.courseName}</small>
                    )}
                  </div>
                </div>

                <div className="course-add-inp">
                  <label htmlFor="duration" className="label">
                    Duration
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="duration"
                      value={courseData.duration}
                      onChange={e =>
                        handleCourseDataChange("duration", e.target.value)
                      }
                      placeholder="Enter Duration"
                      className="inp-field-box"
                    />
                    {errors.duration && (
                      <small className="error">{errors.duration}</small>
                    )}
                  </div>
                </div>

                <div className="course-add-inp">
                  <label htmlFor="level" className="label">
                    Level
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="level"
                      value={courseData.level}
                      onChange={e =>
                        handleCourseDataChange("level", e.target.value)
                      }
                      placeholder="Enter Level"
                      className="inp-field-box"
                    />
                    {errors.level && (
                      <small className="error">{errors.level}</small>
                    )}
                  </div>
                </div>

                <div className="course-add-inp">
                  <label htmlFor="EligibilityCriteria" className="label">
                    EligibilityCriteria
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="eligibilityCriteria"
                      value={courseData.eligibilityCriteria}
                      onChange={e =>
                        handleCourseDataChange(
                          "eligibilityCriteria",
                          e.target.value,
                        )
                      }
                      placeholder="Enter EligibilityCriteria"
                      className="inp-field-box"
                    />
                    {errors.eligibilityCriteria && (
                      <small className="error">
                        {errors.eligibilityCriteria}
                      </small>
                    )}
                  </div>
                </div>

                <div className="course-add-inp">
                  <label htmlFor="totalSeats" className="label">
                    TotalSeats
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="totalSeats"
                      value={courseData.totalSeats}
                      onChange={e =>
                        handleCourseDataChange("totalSeats", e.target.value)
                      }
                      placeholder="Enter TotalSeats"
                      className="inp-field-box"
                    />
                    {errors.totalSeats && (
                      <small className="error">{errors.totalSeats}</small>
                    )}
                  </div>
                </div>

                <div className="course-add-inp">
                  <label htmlFor="tuitionFee" className="label">
                    TuitionFee
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="tuitionFee"
                      value={courseData.tuitionFee}
                      onChange={e =>
                        handleCourseDataChange("tuitionFee", e.target.value)
                      }
                      placeholder="Enter TuitionFee"
                      className="inp-field-box"
                    />
                    {errors.tuitionFee && (
                      <small className="error">{errors.tuitionFee}</small>
                    )}
                  </div>
                </div>

                <div className="course-add-inp">
                  <label htmlFor="admissionFee" className="label">
                    AdmissionFee
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="admissionFee"
                      value={courseData.admissionFee}
                      onChange={e =>
                        handleCourseDataChange("admissionFee", e.target.value)
                      }
                      placeholder="Enter AdmissionFee"
                      className="inp-field-box"
                    />
                    {errors.admissionFee && (
                      <small className="error">{errors.admissionFee}</small>
                    )}
                  </div>
                </div>

                <div className="course-add-inp">
                  <label htmlFor="intakeSeats" className="label">
                    Intake Seats
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="intakeSeats"
                      value={courseData.intakeSeats}
                      onChange={e =>
                        handleCourseDataChange("intakeSeats", e.target.value)
                      }
                      placeholder="Enter Intake Seats"
                      className="inp-field-box"
                    />
                    {errors.intakeSeats && (
                      <small className="error">{errors.intakeSeats}</small>
                    )}
                  </div>
                </div>

                <div className="course-add-inp">
                  <label htmlFor="modeOfStudy">Mode Of Study</label>
                  <div className="inp-err">
                    <Dropdown
                      id="modeOfStudy"
                      value={courseData.modeOfStudy}
                      onChange={e =>
                        handleCourseDataChange("modeOfStudy", e.value)
                      }
                      optionLabel="name"
                      options={modeofStudyOptions}
                      placeholder=" Select Mode of Study"
                    />
                    {errors.modeOfStudy && (
                      <small className="error">{errors.modeOfStudy}</small>
                    )}
                  </div>
                </div>
                <div className="course-add-inp">
                  <label htmlFor="description" className="label">
                    Description
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="description"
                      value={courseData.description}
                      onChange={e =>
                        handleCourseDataChange("description", e.target.value)
                      }
                      placeholder="Enter Description"
                      className="inp-field-box"
                    />
                    {errors.description && (
                      <small className="error">{errors.description}</small>
                    )}
                  </div>
                </div>

                {/* Cutoff Section */}
                {courseData.institution && (
                  <div className="course-add-inp">
                    <label>Cutoffs</label>
                    <div className="cutoff-section">
                      <div className="cutoff-input-form">
                        <div className="mb-2">
                          <label htmlFor="year">Year</label>
                          <div className="inp-err">
                            <Calendar
                              id="year"
                              value={
                                currentCutoff.year
                                  ? new Date(currentCutoff.year, 0)
                                  : null
                              }
                              onChange={e => {
                                const selectedYear = e.value
                                  ? new Date(e.value).getFullYear()
                                  : null
                                setCurrentCutoff({
                                  ...currentCutoff,
                                  year: selectedYear,
                                })
                              }}
                              view="year"
                              dateFormat="yy"
                              placeholder="Select Year"
                              showIcon
                            />
                          </div>
                        </div>

                        <div className="mb-2">
                          <label htmlFor="quota">Quota</label>
                          <div className="inp-err">
                            <Dropdown
                              id="quota"
                              value={currentCutoff.quota}
                              onChange={e =>
                                setCurrentCutoff({
                                  ...currentCutoff,
                                  quota: e.value,
                                })
                              }
                              options={quotaOptions}
                              optionLabel="name"
                              placeholder="Select Quota"
                            />
                          </div>
                        </div>

                        {courseData.institution?.category?.toUpperCase() !== "MEDICAL" && (
                          <div className="mb-2">
                            <label htmlFor="cutoff">Cutoff</label>
                            <div className="inp-err">
                              <InputText
                                id="cutoff"
                                value={currentCutoff.cutoff}
                                onChange={e =>
                                  setCurrentCutoff({
                                    ...currentCutoff,
                                    cutoff: e.target.value,
                                  })
                                }
                                placeholder="Enter Cutoff"
                              />
                            </div>
                          </div>
                        )}

                        {courseData.institution?.category?.toUpperCase() === "MEDICAL" && (
                          <div className="rounds-grid">
                            <div>
                              <label htmlFor="round1">Round 1</label>
                              <div className="inp-err">
                                <InputText
                                  id="round1"
                                  value={currentCutoff.rounds.round1}
                                  onChange={e =>
                                    setCurrentCutoff({
                                      ...currentCutoff,
                                      rounds: {
                                        ...currentCutoff.rounds,
                                        round1: e.target.value,
                                      },
                                    })
                                  }
                                  placeholder="Round 1 Cutoff"
                                />
                              </div>
                            </div>

                            <div>
                              <label htmlFor="round2">Round 2</label>
                              <div className="inp-err">
                                <InputText
                                  id="round2"
                                  value={currentCutoff.rounds.round2}
                                  onChange={e =>
                                    setCurrentCutoff({
                                      ...currentCutoff,
                                      rounds: {
                                        ...currentCutoff.rounds,
                                        round2: e.target.value,
                                      },
                                    })
                                  }
                                  placeholder="Round 2 Cutoff"
                                />
                              </div>
                            </div>

                            <div>
                              <label htmlFor="mopUpRound">Mop-Up Round</label>
                              <div className="inp-err">
                                <InputText
                                  id="mopUpRound"
                                  value={currentCutoff.rounds.mopUpRound}
                                  onChange={e =>
                                    setCurrentCutoff({
                                      ...currentCutoff,
                                      rounds: {
                                        ...currentCutoff.rounds,
                                        mopUpRound: e.target.value,
                                      },
                                    })
                                  }
                                  placeholder="Mop-Up Round Cutoff"
                                />
                              </div>
                            </div>

                            <div>
                              <label htmlFor="strayVacancy">Stray Vacancy</label>
                              <div className="inp-err">
                                <InputText
                                  id="strayVacancy"
                                  value={currentCutoff.rounds.strayVacancy}
                                  onChange={e =>
                                    setCurrentCutoff({
                                      ...currentCutoff,
                                      rounds: {
                                        ...currentCutoff.rounds,
                                        strayVacancy: e.target.value,
                                      },
                                    })
                                  }
                                  placeholder="Stray Vacancy Cutoff"
                                />
                              </div>
                            </div>
                          </div>
                        )}

                        <div className="add-cutoff-btn">
                          <Button
                            type="button"
                            color="primary"
                            size="sm"
                            onClick={handleAddCutoff}
                          >
                            Add Cutoff
                          </Button>
                        </div>
                      </div>

                      {courseData.cutoffs.length > 0 && (
                        <div className="cutoff-list mt-3">
                          <h6>Added Cutoffs:</h6>
                          {courseData.cutoffs.map((cutoff, index) => (
                            <div
                              key={index}
                              className="cutoff-item p-2 border rounded mb-2"
                            >
                              <div className="d-flex justify-content-between align-items-start">
                                <div>
                                  <strong>Year: {cutoff.year}</strong>
                                  <p className="mb-0">Quota: {cutoff.quota}</p>
                                  {courseData.institution?.category?.toUpperCase() !== "MEDICAL" && (
                                    <p className="mb-0">Cutoff: {cutoff.cutoff}</p>
                                  )}
                                  {courseData.institution?.category?.toUpperCase() === "MEDICAL" && (
                                    <div className="rounds-values">
                                      <small>
                                        Round 1: {cutoff.rounds.round1}
                                      </small>
                                      <small className="ms-2">
                                        Round 2: {cutoff.rounds.round2}
                                      </small>
                                      <small className="ms-2">
                                        Mop-Up: {cutoff.rounds.mopUpRound}
                                      </small>
                                      <small className="ms-2">
                                        Stray: {cutoff.rounds.strayVacancy}
                                      </small>
                                    </div>
                                  )}
                                </div>
                                <Button
                                  type="button"
                                  color="danger"
                                  size="sm"
                                  onClick={() => handleRemoveCutoff(index)}
                                >
                                  Remove
                                </Button>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                )}

              </div>

              <div className="save-cancel-btn mt-4 d-flex align-items-center justify-content-end gap-3">
                <Button
                  type="button"
                  outline
                  color="danger"
                  className="waves-effect waves-light"
                  onClick={() => {
                    navigate(-1)
                  }}
                >
                  Cancel
                </Button>
                <Button
                  type="button"
                  color="secondary"
                  className="waves-effect waves-light"
                  disabled={loading}
                  onClick={() => {
                    addCourse()
                  }}
                >
                  {loading ? <Spinner size="sm" /> : "Add"}
                </Button>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default AddCourse
